import {Card, Container, Modal, Row, Col} from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import {useEffect, useState} from "react";
import {getCollection} from "../services/firestoreGetCollection";
import {Button} from "react-bootstrap";

export function Articles() {
    const [firstThree, setFirstThree] = useState([]);
    
    useEffect(() => {
        async function loadArticles() {
            const articles = await getCollection("articles")
            setFirstThree(articles.sort(function(x, y){
                return y.date - x.date
            }).slice(0, 3))
        }

        loadArticles()
    }, [])
    
    return (
        <Container id="nieuws" fluid className="bgWhite bg-waves bg-texture-noise skewedBoth section-padding">
            <div className="skewedBothContent">
                <div className="container-modern">
                    <div className="text-center mb-5 fade-in">
                        <h2 className="font-type heading-lg hoofding">Nieuws</h2>
                        <p className="text-lg text-muted">
                            Blijf op de hoogte van alle activiteiten en evenementen
                        </p>
                    </div>
                    
                    <div className="articles-grid">
                        {firstThree.length > 0 && firstThree.map((article, index) => (
                            <Article 
                                key={article.albumName || index} 
                                article={article} 
                                index={index}
                            />
                        ))}
                    </div>
                    
                    {firstThree.length === 0 && (
                        <div className="text-center py-5">
                            <div className="card-modern">
                                <div className="empty-state">
                                    <i className="fas fa-newspaper mb-3"></i>
                                    <h4 className="text-muted mb-3">Geen nieuws beschikbaar</h4>
                                    <p className="text-muted">Er zijn momenteel geen nieuwsartikelen om weer te geven.</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Container>
    );
}

export function Article({article, index}) {
    const [articleShow, setArticleShow] = useState(false);

    return (
        <>
            <div className={`article-card-wrapper article-animate-${(index % 3) + 1}`}>
                <div className="article-card">
                    <div className="article-image-placeholder">
                        <div className="article-category-badge">
                            <i className="fas fa-newspaper me-2"></i>
                            Nieuws
                        </div>
                        <div className="article-date-overlay">
                            {article.date && `${article.date.toDate().toLocaleDateString('nl-BE', {
                                day: '2-digit',
                                month: 'short'
                            })}`}
                        </div>
                    </div>
                    
                    <div className="article-content">
                        <div className="article-meta">
                            <span className="article-date">
                                <i className="fas fa-calendar-alt me-2"></i>
                                {article.date && `${article.date.toDate().toLocaleDateString('nl-BE', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}`}
                            </span>
                        </div>
                        
                        <h3 className="article-title">{article.title}</h3>
                        
                        <p className="article-excerpt">
                            {article.content ? 
                                `${article.content.substr(0, 150)}${article.content.length > 150 ? '...' : ''}` 
                                : 'Geen inhoud beschikbaar'
                            }
                        </p>
                        
                        <div className="article-footer">
                            <button 
                                onClick={() => setArticleShow(true)} 
                                className="btn-primary-modern btn-sm"
                            >
                                <i className="fas fa-book-open me-2"></i>
                                Lees meer
                            </button>
                            
                            <span className="reading-time">
                                <i className="fas fa-clock me-1"></i>
                                {Math.ceil((article.content?.length || 0) / 200)} min
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
            <Modal show={articleShow} onHide={() => setArticleShow(false)} size="lg" centered>
                <Modal.Header closeButton className="border-0 pb-0">
                    <div>
                        <Modal.Title className="font-type" style={{ color: 'var(--primary-purple)' }}>
                            {article.title}
                        </Modal.Title>
                        <div className="text-muted mt-2">
                            <i className="fas fa-calendar-alt me-2"></i>
                            {article.date && `${article.date.toDate().toLocaleDateString('nl-BE', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}`}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="pt-3">
                    <div style={{ lineHeight: '1.8', fontSize: '1.1rem' }}>
                        {article.content?.split('\n').map((paragraph, index) => (
                            <p key={index} className="mb-3">{paragraph}</p>
                        )) || 'Geen inhoud beschikbaar'}
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                    <button onClick={() => setArticleShow(false)} className="btn-secondary-modern">
                        <i className="fas fa-times me-2"></i>
                        Sluiten
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

const getWindowDimensions = () => {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width, height
    }
}

export const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions(getWindowDimensions())
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return windowDimensions
}